<div id="app" class="{{className}}">
  <div class="app__container" infiniteScroll [infiniteScrollDistance]="0.2" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false">
    <div class="app__wrapper">
      <!--infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false"-->
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer *ngIf="className != 'app--dark'"></app-footer>
</div>
